import log from 'loglevel'

const apiHostAddress = (function () {
  let hostname = window.location.hostname.split('.');
  
  // if a port is used or localhost is the hostname
  const isLocalhost = 
    window.location.origin.split(':') > 2 || 
    (hostname.length === 1 && hostname[0] === 'localhost');

  if (isLocalhost) {
    return 'http://'+ hostname.join('.') +':8000  ';
  }

  if (hostname[0] === 'sev' || hostname[0] === 'fawas') {
    hostname.splice(0, 1, 'api');
  } else {
    hostname.unshift('api');
  }

  var url = hostname.join('.');
  log.debug('Backend Address: ' + url)
  return url
})();

export default apiHostAddress;